import { combineReducers } from "redux"
// import * as types from './actions.js'
import menu from "./menu/reducer"
import profile from "./profile/reducer"
import businessLines from "./business-lines/reducer"
import taxCenter from "./tax-center/reducer"
import bankCard from "./bank-card/reducer"
import dataExport from "./data-export/reducer"
import workHours from "./work-hours/reducer"
import vehicles from "./vehicles/reducer"
import faveTxns from "./favorite-transactions/reducer"

const accountReducer = combineReducers({
  menu,
  profile,
  businessLines,
  taxCenter,
  bankCard,
  dataExport,
  workHours,
  vehicles,
  faveTxns
})

export default accountReducer



// WEBPACK FOOTER //
// ./src/account/reducer.js